/**
 * purit-quiz-widget.js
 * Widget quiz Purit — zero dipendenze, funziona in qualsiasi pagina HTML.
 *
 * Utilizzo:
 *   <div id="purit-quiz"></div>
 *   <script src="purit-quiz-widget.js"></script>
 *   <script>PuritQuiz.init('#purit-quiz');</script>
 *
 * Opzioni:
 *   PuritQuiz.init('#purit-quiz', {
 *     onComplete: function(result) { console.log(result); }
 *   });
 */
(function () {
  'use strict';

  /* ─── DATI CAP ─────────────────────────────────────────────────────────── */

  var CAP_DATA = {
    '10100': { city: 'Torino', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '15100': { city: 'Alessandria', region: 'Piemonte', hardness: 'Moderata', hf: 0.98 },
    '14100': { city: 'Asti', region: 'Piemonte', hardness: 'Moderata', hf: 0.98 },
    '12100': { city: 'Cuneo', region: 'Piemonte', hardness: 'Morbida', hf: 1.12 },
    '28100': { city: 'Novara', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '13100': { city: 'Vercelli', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '13900': { city: 'Biella', region: 'Piemonte', hardness: 'Morbida', hf: 1.10 },
    '28921': { city: 'Verbania', region: 'Piemonte', hardness: 'Morbida', hf: 1.15 },
    '11100': { city: 'Aosta', region: "Valle d'Aosta", hardness: 'Morbida', hf: 1.20 },
    '16100': { city: 'Genova', region: 'Liguria', hardness: 'Morbida', hf: 1.18 },
    '17100': { city: 'Savona', region: 'Liguria', hardness: 'Morbida', hf: 1.15 },
    '18100': { city: 'Imperia', region: 'Liguria', hardness: 'Moderata', hf: 1.05 },
    '19100': { city: 'La Spezia', region: 'Liguria', hardness: 'Morbida', hf: 1.12 },
    '20100': { city: 'Milano', region: 'Lombardia', hardness: 'Dura', hf: 0.85 },
    '24100': { city: 'Bergamo', region: 'Lombardia', hardness: 'Moderata', hf: 0.95 },
    '25100': { city: 'Brescia', region: 'Lombardia', hardness: 'Moderata', hf: 0.95 },
    '22100': { city: 'Como', region: 'Lombardia', hardness: 'Morbida', hf: 1.10 },
    '26100': { city: 'Cremona', region: 'Lombardia', hardness: 'Dura', hf: 0.82 },
    '23100': { city: 'Lecco', region: 'Lombardia', hardness: 'Morbida', hf: 1.08 },
    '26900': { city: 'Lodi', region: 'Lombardia', hardness: 'Moderata', hf: 0.92 },
    '46100': { city: 'Mantova', region: 'Lombardia', hardness: 'Dura', hf: 0.80 },
    '20900': { city: 'Monza', region: 'Lombardia', hardness: 'Dura', hf: 0.85 },
    '27100': { city: 'Pavia', region: 'Lombardia', hardness: 'Moderata', hf: 0.92 },
    '23900': { city: 'Sondrio', region: 'Lombardia', hardness: 'Morbida', hf: 1.15 },
    '21100': { city: 'Varese', region: 'Lombardia', hardness: 'Morbida', hf: 1.10 },
    '39100': { city: 'Bolzano', region: 'Alto Adige', hardness: 'Morbida', hf: 1.22 },
    '38100': { city: 'Trento', region: 'Trentino', hardness: 'Morbida', hf: 1.18 },
    '30100': { city: 'Venezia', region: 'Veneto', hardness: 'Molto dura', hf: 0.72 },
    '36100': { city: 'Vicenza', region: 'Veneto', hardness: 'Dura', hf: 0.82 },
    '37100': { city: 'Verona', region: 'Veneto', hardness: 'Dura', hf: 0.80 },
    '35100': { city: 'Padova', region: 'Veneto', hardness: 'Dura', hf: 0.82 },
    '31100': { city: 'Treviso', region: 'Veneto', hardness: 'Moderata', hf: 0.95 },
    '32100': { city: 'Belluno', region: 'Veneto', hardness: 'Morbida', hf: 1.15 },
    '45100': { city: 'Rovigo', region: 'Veneto', hardness: 'Molto dura', hf: 0.72 },
    '34100': { city: 'Trieste', region: 'Friuli V.G.', hardness: 'Molto dura', hf: 0.72 },
    '33100': { city: 'Udine', region: 'Friuli V.G.', hardness: 'Moderata', hf: 1.00 },
    '34170': { city: 'Gorizia', region: 'Friuli V.G.', hardness: 'Dura', hf: 0.85 },
    '33170': { city: 'Pordenone', region: 'Friuli V.G.', hardness: 'Moderata', hf: 0.98 },
    '40100': { city: 'Bologna', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '44100': { city: 'Ferrara', region: 'Emilia-Romagna', hardness: 'Molto dura', hf: 0.72 },
    '47100': { city: 'Forlì', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 0.98 },
    '42100': { city: 'Reggio Emilia', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '41100': { city: 'Modena', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '43100': { city: 'Parma', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '29100': { city: 'Piacenza', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 0.95 },
    '48100': { city: 'Ravenna', region: 'Emilia-Romagna', hardness: 'Molto dura', hf: 0.72 },
    '47900': { city: 'Rimini', region: 'Emilia-Romagna', hardness: 'Dura', hf: 0.85 },
    '50100': { city: 'Firenze', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '52100': { city: 'Arezzo', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '59100': { city: 'Prato', region: 'Toscana', hardness: 'Moderata', hf: 1.02 },
    '51100': { city: 'Pistoia', region: 'Toscana', hardness: 'Moderata', hf: 1.02 },
    '56100': { city: 'Pisa', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '57100': { city: 'Livorno', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '53100': { city: 'Siena', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '58100': { city: 'Grosseto', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '55100': { city: 'Lucca', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '54100': { city: 'Massa', region: 'Toscana', hardness: 'Morbida', hf: 1.10 },
    '06100': { city: 'Perugia', region: 'Umbria', hardness: 'Moderata', hf: 1.00 },
    '05100': { city: 'Terni', region: 'Umbria', hardness: 'Molto dura', hf: 0.75 },
    '60100': { city: 'Ancona', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '63100': { city: 'Ascoli Piceno', region: 'Marche', hardness: 'Moderata', hf: 1.00 },
    '62100': { city: 'Macerata', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '61121': { city: 'Pesaro', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '63900': { city: 'Fermo', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '00100': { city: 'Roma', region: 'Lazio', hardness: 'Molto dura', hf: 0.70 },
    '04100': { city: 'Latina', region: 'Lazio', hardness: 'Dura', hf: 0.82 },
    '03100': { city: 'Frosinone', region: 'Lazio', hardness: 'Molto dura', hf: 0.72 },
    '01100': { city: 'Viterbo', region: 'Lazio', hardness: 'Molto dura', hf: 0.72 },
    '02100': { city: 'Rieti', region: 'Lazio', hardness: 'Molto dura', hf: 0.72 },
    '67100': { city: "L'Aquila", region: 'Abruzzo', hardness: 'Moderata', hf: 1.00 },
    '66100': { city: 'Chieti', region: 'Abruzzo', hardness: 'Dura', hf: 0.85 },
    '65100': { city: 'Pescara', region: 'Abruzzo', hardness: 'Dura', hf: 0.85 },
    '64100': { city: 'Teramo', region: 'Abruzzo', hardness: 'Moderata', hf: 1.00 },
    '86100': { city: 'Campobasso', region: 'Molise', hardness: 'Dura', hf: 0.85 },
    '86170': { city: 'Isernia', region: 'Molise', hardness: 'Moderata', hf: 0.95 },
    '70100': { city: 'Bari', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '71100': { city: 'Foggia', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '72100': { city: 'Brindisi', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '73100': { city: 'Lecce', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '74100': { city: 'Taranto', region: 'Puglia', hardness: 'Molto dura', hf: 0.70 },
    '75100': { city: 'Matera', region: 'Basilicata', hardness: 'Dura', hf: 0.82 },
    '85100': { city: 'Potenza', region: 'Basilicata', hardness: 'Moderata', hf: 1.00 },
    '87100': { city: 'Cosenza', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '88100': { city: 'Catanzaro', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '89100': { city: 'Reggio Calabria', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '80100': { city: 'Napoli', region: 'Campania', hardness: 'Molto dura', hf: 0.70 },
    '81100': { city: 'Caserta', region: 'Campania', hardness: 'Molto dura', hf: 0.72 },
    '82100': { city: 'Benevento', region: 'Campania', hardness: 'Dura', hf: 0.82 },
    '83100': { city: 'Avellino', region: 'Campania', hardness: 'Dura', hf: 0.82 },
    '84100': { city: 'Salerno', region: 'Campania', hardness: 'Dura', hf: 0.85 },
    '90100': { city: 'Palermo', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '91100': { city: 'Trapani', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '92100': { city: 'Agrigento', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '93100': { city: 'Caltanissetta', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '94100': { city: 'Enna', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '95100': { city: 'Catania', region: 'Sicilia', hardness: 'Molto dura', hf: 0.68 },
    '96100': { city: 'Siracusa', region: 'Sicilia', hardness: 'Molto dura', hf: 0.68 },
    '97100': { city: 'Ragusa', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '98100': { city: 'Messina', region: 'Sicilia', hardness: 'Dura', hf: 0.85 },
    '07100': { city: 'Sassari', region: 'Sardegna', hardness: 'Moderata', hf: 1.00 },
    '09100': { city: 'Cagliari', region: 'Sardegna', hardness: 'Dura', hf: 0.85 },
    '08100': { city: 'Nuoro', region: 'Sardegna', hardness: 'Morbida', hf: 1.10 },
    '09170': { city: 'Oristano', region: 'Sardegna', hardness: 'Moderata', hf: 1.00 },
  };

  var PREFIX_FALLBACK = {
    '10': { city: 'Torino area', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '11': { city: "Valle d'Aosta area", region: "Valle d'Aosta", hardness: 'Morbida', hf: 1.18 },
    '12': { city: 'Cuneo area', region: 'Piemonte', hardness: 'Morbida', hf: 1.10 },
    '13': { city: 'Vercelli/Biella area', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '14': { city: 'Asti area', region: 'Piemonte', hardness: 'Moderata', hf: 0.98 },
    '15': { city: 'Alessandria area', region: 'Piemonte', hardness: 'Moderata', hf: 0.98 },
    '16': { city: 'Genova area', region: 'Liguria', hardness: 'Morbida', hf: 1.15 },
    '17': { city: 'Savona area', region: 'Liguria', hardness: 'Morbida', hf: 1.12 },
    '18': { city: 'Imperia area', region: 'Liguria', hardness: 'Moderata', hf: 1.05 },
    '19': { city: 'La Spezia area', region: 'Liguria', hardness: 'Morbida', hf: 1.10 },
    '20': { city: 'Milano area', region: 'Lombardia', hardness: 'Dura', hf: 0.85 },
    '21': { city: 'Varese area', region: 'Lombardia', hardness: 'Morbida', hf: 1.10 },
    '22': { city: 'Como area', region: 'Lombardia', hardness: 'Morbida', hf: 1.08 },
    '23': { city: 'Sondrio/Lecco area', region: 'Lombardia', hardness: 'Morbida', hf: 1.10 },
    '24': { city: 'Bergamo area', region: 'Lombardia', hardness: 'Moderata', hf: 0.95 },
    '25': { city: 'Brescia area', region: 'Lombardia', hardness: 'Moderata', hf: 0.95 },
    '26': { city: 'Cremona/Lodi area', region: 'Lombardia', hardness: 'Dura', hf: 0.85 },
    '27': { city: 'Pavia area', region: 'Lombardia', hardness: 'Moderata', hf: 0.92 },
    '28': { city: 'Novara area', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '29': { city: 'Piacenza area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 0.95 },
    '30': { city: 'Venezia area', region: 'Veneto', hardness: 'Molto dura', hf: 0.72 },
    '31': { city: 'Treviso area', region: 'Veneto', hardness: 'Moderata', hf: 0.95 },
    '32': { city: 'Belluno area', region: 'Veneto', hardness: 'Morbida', hf: 1.15 },
    '33': { city: 'Udine/Pordenone area', region: 'Friuli V.G.', hardness: 'Moderata', hf: 0.98 },
    '34': { city: 'Trieste/Gorizia area', region: 'Friuli V.G.', hardness: 'Molto dura', hf: 0.72 },
    '35': { city: 'Padova area', region: 'Veneto', hardness: 'Dura', hf: 0.82 },
    '36': { city: 'Vicenza area', region: 'Veneto', hardness: 'Dura', hf: 0.82 },
    '37': { city: 'Verona area', region: 'Veneto', hardness: 'Dura', hf: 0.80 },
    '38': { city: 'Trento area', region: 'Trentino', hardness: 'Morbida', hf: 1.18 },
    '39': { city: 'Bolzano area', region: 'Alto Adige', hardness: 'Morbida', hf: 1.22 },
    '40': { city: 'Bologna area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '41': { city: 'Modena area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '42': { city: 'Reggio Emilia area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '43': { city: 'Parma area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '44': { city: 'Ferrara area', region: 'Emilia-Romagna', hardness: 'Molto dura', hf: 0.72 },
    '45': { city: 'Rovigo area', region: 'Veneto', hardness: 'Molto dura', hf: 0.72 },
    '46': { city: 'Mantova area', region: 'Lombardia', hardness: 'Dura', hf: 0.80 },
    '47': { city: 'Forlì/Rimini area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 0.98 },
    '48': { city: 'Ravenna area', region: 'Emilia-Romagna', hardness: 'Molto dura', hf: 0.72 },
    '50': { city: 'Firenze area', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '51': { city: 'Pistoia area', region: 'Toscana', hardness: 'Moderata', hf: 1.02 },
    '52': { city: 'Arezzo area', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '53': { city: 'Siena area', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '54': { city: 'Massa area', region: 'Toscana', hardness: 'Morbida', hf: 1.08 },
    '55': { city: 'Lucca area', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '56': { city: 'Pisa area', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '57': { city: 'Livorno area', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '58': { city: 'Grosseto area', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '59': { city: 'Prato area', region: 'Toscana', hardness: 'Moderata', hf: 1.02 },
    '60': { city: 'Ancona area', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '61': { city: 'Pesaro area', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '62': { city: 'Macerata area', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '63': { city: 'Ascoli/Fermo area', region: 'Marche', hardness: 'Moderata', hf: 1.00 },
    '64': { city: 'Teramo area', region: 'Abruzzo', hardness: 'Moderata', hf: 1.00 },
    '65': { city: 'Pescara area', region: 'Abruzzo', hardness: 'Dura', hf: 0.85 },
    '66': { city: 'Chieti area', region: 'Abruzzo', hardness: 'Dura', hf: 0.85 },
    '67': { city: "L'Aquila area", region: 'Abruzzo', hardness: 'Moderata', hf: 1.00 },
    '68': { city: 'Isernia area', region: 'Molise', hardness: 'Moderata', hf: 0.95 },
    '70': { city: 'Bari area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '71': { city: 'Foggia area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '72': { city: 'Brindisi area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '73': { city: 'Lecce area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '74': { city: 'Taranto area', region: 'Puglia', hardness: 'Molto dura', hf: 0.70 },
    '75': { city: 'Matera area', region: 'Basilicata', hardness: 'Dura', hf: 0.82 },
    '76': { city: 'Barletta area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '80': { city: 'Napoli area', region: 'Campania', hardness: 'Molto dura', hf: 0.70 },
    '81': { city: 'Caserta area', region: 'Campania', hardness: 'Molto dura', hf: 0.72 },
    '82': { city: 'Benevento area', region: 'Campania', hardness: 'Dura', hf: 0.82 },
    '83': { city: 'Avellino area', region: 'Campania', hardness: 'Dura', hf: 0.82 },
    '84': { city: 'Salerno area', region: 'Campania', hardness: 'Dura', hf: 0.85 },
    '85': { city: 'Potenza area', region: 'Basilicata', hardness: 'Moderata', hf: 1.00 },
    '86': { city: 'Campobasso area', region: 'Molise', hardness: 'Dura', hf: 0.85 },
    '87': { city: 'Cosenza area', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '88': { city: 'Catanzaro area', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '89': { city: 'Reggio Calabria area', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '90': { city: 'Palermo area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '91': { city: 'Trapani area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '92': { city: 'Agrigento area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '93': { city: 'Caltanissetta area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '94': { city: 'Enna area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '95': { city: 'Catania area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.68 },
    '96': { city: 'Siracusa area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.68 },
    '97': { city: 'Ragusa area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '98': { city: 'Messina area', region: 'Sicilia', hardness: 'Dura', hf: 0.85 },
  };

  /* ─── LOGICA DI CALCOLO ─────────────────────────────────────────────────── */

  var PRODUCTS = {
    tap:    { name: 'Filtro Rubinetto', maxDays: 90,  minDays: 26, durationBoost: 1.32 },
    shower: { name: 'Filtro Doccia',    maxDays: 180, minDays: 63, durationBoost: 1.40 },
  };
  var PEOPLE_FACTOR   = { '1': 1.15, '2-3': 1.05, '4-6': 0.82, '7+': 0.62 };
  var USAGE_FACTOR    = { drink: 1.08, drink_cook: 1.00, drink_cook_veg: 0.88, intensive: 0.72 };
  var BUILDING_FACTOR = { '<10': 1.08, '10-30': 1.03, '30-50': 0.88, '50+': 0.74 };

  function getCapData(cap) {
    var clean = (cap || '').replace(/\D/g, '').padStart ? (cap || '').replace(/\D/g, '') : (cap || '').replace(/\D/g, '');
    while (clean.length < 5) clean = '0' + clean;
    return CAP_DATA[clean] || PREFIX_FALLBACK[clean.slice(0, 2)] || { city: 'Italia', region: '', hardness: 'Moderata', hf: 1.00 };
  }

  function applyMaintenanceFactor(buildingAge, workType, workYears) {
    if (buildingAge !== '30-50' && buildingAge !== '50+') return null;
    if (!workType || workType === 'none') return null;
    var baseBf = BUILDING_FACTOR[buildingAge];
    var maxRecovery = workType === 'full' ? 0.95 : 0.60;
    var yearsMap = { '<2': 1, '2-5': 3.5, '5-10': 7.5 };
    var years = workYears ? (yearsMap[workYears] || 0) : 0;
    var decay = Math.max(0, 1 - years / 10);
    return parseFloat((baseBf + (1.00 - baseBf) * maxRecovery * decay).toFixed(3));
  }

  function getProblemFactor(problems) {
    if (!problems || !problems.length || problems.indexOf('none') !== -1) return 1.00;
    var count = problems.filter(function (p) { return p !== 'none'; }).length;
    if (count >= 3) return 0.72;
    if (count === 2) return 0.84;
    return 0.93;
  }

  function calculateFilterDuration(answers, selectedProducts) {
    if (!selectedProducts) selectedProducts = ['tap', 'shower'];
    var capInfo       = getCapData(answers.cap);
    var peopleFactor  = PEOPLE_FACTOR[answers.people]       || 1.00;
    var usageFactor   = USAGE_FACTOR[answers.usage]          || 1.00;
    var problemFactor = getProblemFactor(answers.problems);
    var baseBf        = BUILDING_FACTOR[answers.buildingAge] || 1.00;
    var maintFactor   = applyMaintenanceFactor(answers.buildingAge, answers.maintenanceWork, answers.maintenanceYears);
    var buildingFactor = maintFactor !== null ? maintFactor : baseBf;
    var products = {};
    selectedProducts.forEach(function (id) {
      var p = PRODUCTS[id];
      if (!p) return;
      var usageApplied = id === 'tap' ? usageFactor : 1.00;
      var combined = capInfo.hf * peopleFactor * usageApplied * buildingFactor * problemFactor * p.durationBoost;
      var days   = Math.round(Math.min(p.maxDays, Math.max(p.minDays, p.maxDays * combined)));
      var months = parseFloat((days / 30).toFixed(1));
      products[id] = { days: days, months: months, name: p.name };
    });
    return { capInfo: capInfo, products: products };
  }

  /* ─── QUIZ OPZIONI ──────────────────────────────────────────────────────── */

  var PEOPLE_OPTIONS = [
    { key: '1',   label: 'Solo io' },
    { key: '2-3', label: 'Coppia o piccola famiglia' },
    { key: '4-6', label: 'Famiglia numerosa' },
    { key: '7+',  label: 'Uso condiviso (7+)' },
  ];
  var USAGE_OPTIONS = [
    { key: 'drink',          label: 'Solo per bere' },
    { key: 'drink_cook',     label: 'Bere e cucinare' },
    { key: 'drink_cook_veg', label: 'Bere, cucinare e lavare frutta/verdura' },
    { key: 'intensive',      label: 'Uso intensivo (bere, cucinare, caffè, ghiaccio, ecc.)' },
  ];
  var BUILDING_OPTIONS = [
    { key: '<10',   label: 'Meno di 10 anni' },
    { key: '10-30', label: '10–30 anni' },
    { key: '30-50', label: '30–50 anni' },
    { key: '50+',   label: 'Oltre 50 anni' },
  ];
  var WORK_TYPE_OPTIONS = [
    { key: 'none',     label: 'Nessun lavoro recente' },
    { key: 'ordinary', label: 'Manutenzione ordinaria (pulizia, riparazioni parziali)' },
    { key: 'full',     label: 'Sostituzione tubature (rifacimento impianto completo)' },
  ];
  var WORK_YEARS_OPTIONS = [
    { key: '<2',  label: 'Meno di 2 anni fa' },
    { key: '2-5', label: '2–5 anni fa' },
    { key: '5-10',label: '5–10 anni fa' },
  ];
  var PROBLEM_OPTIONS = [
    { key: 'limescale', label: 'Calcare (depositi bianchi)' },
    { key: 'chlorine',  label: 'Odore o sapore di cloro' },
    { key: 'rust',      label: 'Ruggine o macchie rossastre' },
    { key: 'turbid',    label: 'Acqua torbida o di colore strano' },
    { key: 'none',      label: 'Nessun problema' },
  ];

  /* ─── CSS ───────────────────────────────────────────────────────────────── */

  var CSS = [
    '.pq-wrap{font-family:"Manrope",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;max-width:560px;margin:0 auto;padding:32px 24px;background:#fff;border-radius:20px;box-sizing:border-box;border:1px solid #D0E2F4}',
    '.pq-wrap *{box-sizing:border-box}',
    '.pq-progress-bar{height:6px;background:#d3d1c7;border-radius:3px;overflow:hidden;margin-bottom:8px}',
    '.pq-progress-fill{height:100%;background:#639922;border-radius:3px;transition:width .3s ease}',
    '.pq-progress-text{font-size:13px;color:#888780;text-align:right;margin-bottom:28px}',
    '.pq-steps-nav{display:flex;align-items:center;justify-content:center;gap:0;margin-bottom:28px}',
    '.pq-step-dot{width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;border:2px solid #D0E2F4;background:#fff;color:#7A94B0;transition:all .3s;flex-shrink:0}',
    '.pq-step-dot.active{border-color:#639922;background:#639922;color:#fff;box-shadow:0 0 0 4px rgba(99,153,34,0.15)}',
    '.pq-step-dot.done{border-color:#639922;background:#EDF5E0;color:#639922}',
    '.pq-step-line{width:48px;height:2px;background:#D0E2F4;transition:background .3s}',
    '.pq-step-line.done{background:#639922}',
    '.pq-question{font-size:22px;font-weight:700;color:#0B2545;margin:0 0 8px}',
    '.pq-hint{font-size:14px;color:#7A94B0;margin:0 0 20px}',
    '.pq-section-label{font-size:15px;font-weight:600;color:#0B2545;margin:20px 0 10px}',
    '.pq-cap-input{display:block;width:100%;padding:16px;font-size:24px;font-family:"Manrope",monospace;letter-spacing:8px;text-align:center;border:1.5px solid #D0E2F4;border-radius:12px;background:#fff;color:#0B2545;outline:none;margin-bottom:16px}',
    '.pq-cap-input:focus{border-color:#639922}',
    '.pq-cap-card{display:flex;align-items:center;gap:12px;background:#f7fcff;border:1px solid #D0E2F4;border-radius:12px;padding:14px;margin-bottom:4px}',
    '.pq-cap-icon{font-size:20px}',
    '.pq-cap-city{font-size:15px;font-weight:700;color:#0B2545;margin:0 0 2px}',
    '.pq-cap-hardness{font-size:13px;color:#7A94B0;margin:0}',
    '.pq-cap-hardness b{color:#1E4D8C}',
    '.pq-options{display:flex;flex-direction:column;gap:10px}',
    '.pq-option{display:flex;align-items:center;gap:12px;background:#fff;border:1.5px solid #D0E2F4;border-radius:12px;padding:14px 16px;cursor:pointer;transition:border-color .15s,background .15s}',
    '.pq-option:hover{border-color:#639922;background:#FFFFFF}',
    '.pq-option.selected{border-color:#639922;background:#EDF5E0}',
    '.pq-radio{width:22px;height:22px;border-radius:50%;border:2px solid #D0E2F4;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:border-color .15s}',
    '.pq-option.selected .pq-radio{border-color:#639922}',
    '.pq-radio-dot{width:10px;height:10px;border-radius:50%;background:#639922;display:none}',
    '.pq-option.selected .pq-radio-dot{display:block}',
    '.pq-checkbox{width:22px;height:22px;border-radius:6px;border:2px solid #D0E2F4;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:border-color .15s,background .15s;font-size:14px;color:#fff}',
    '.pq-option.selected .pq-checkbox{border-color:#639922;background:#639922}',
    '.pq-option-label{font-size:15px;color:#0B2545;line-height:1.4}',
    '.pq-option.selected .pq-option-label{font-weight:600;color:#0B2545}',
    '.pq-buttons{display:flex;align-items:center;gap:12px;margin-top:32px}',
    '.pq-back{display:flex;align-items:center;gap:6px;padding:14px 16px;font-size:15px;font-weight:600;color:#3A5070;background:none;border:2px solid #D0E2F4;cursor:pointer;border-radius:12px;transition:all .15s}',
    '.pq-back:hover{background:#f7fcff;border-color:#1E4D8C}',
    '.pq-next{flex:1;padding:16px;font-size:16px;font-weight:700;color:#fff;background:#639922;border:none;border-radius:12px;cursor:pointer;transition:opacity .15s,background .15s;box-shadow:0 4px 20px rgba(99,153,34,0.25)}',
    '.pq-next:hover:not(:disabled){background:#4E7A1B}',
    '.pq-next:disabled{opacity:.4;cursor:not-allowed}',
    /* risultati */
    '.pq-results-title{font-size:22px;font-weight:800;color:#0B2545;margin:0 0 4px}',
    '.pq-results-sub{font-size:14px;color:#7A94B0;margin:0 0 24px}',
    '.pq-result-card{background:#f7fcff;border:1px solid #D0E2F4;border-radius:14px;padding:20px;margin-bottom:14px}',
    '.pq-result-card-header{display:flex;align-items:center;gap:12px;margin-bottom:16px}',
    '.pq-result-icon{width:44px;height:44px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0}',
    '.pq-result-name{font-size:16px;font-weight:700;color:#0B2545;margin:0 0 2px}',
    '.pq-result-hardness{font-size:13px;color:#7A94B0;margin:0}',
    '.pq-result-days{font-size:52px;font-weight:800;color:#0B2545;line-height:1;margin:0 0 4px;font-variant-numeric:tabular-nums}',
    '.pq-result-days-label{font-size:14px;color:#7A94B0;margin:0 0 14px}',
    '.pq-result-bar-bg{height:8px;background:#D0E2F4;border-radius:4px;overflow:hidden;margin-bottom:8px}',
    '.pq-result-bar-fill{height:100%;border-radius:4px}',
    '.pq-result-months{font-size:13px;color:#7A94B0}',
    '.pq-restart{width:100%;margin-top:8px;padding:14px;font-size:15px;font-weight:600;color:#3A5070;background:#fff;border:2px solid #D0E2F4;border-radius:12px;cursor:pointer;transition:all .15s}',
    '.pq-restart:hover{background:#f7fcff;border-color:#1E4D8C}',
    '.pq-water-info{background:#f7fcff;border:1px solid #D0E2F4;border-radius:10px;padding:12px 14px;margin-bottom:20px;font-size:13px;color:#0B2545}',
    '.pq-water-info b{color:#1E4D8C}',
  ].join('');

  /* ─── STATO DEL QUIZ ────────────────────────────────────────────────────── */

  function createState() {
    return {
      stepIndex: 0,
      cap: '',
      capInfo: null,
      people: '',
      usage: '',
      buildingAge: '',
      maintenanceWork: '',
      maintenanceYears: '',
      problems: [],
    };
  }

  function getSteps(state) {
    var needsMaint = state.buildingAge === '30-50' || state.buildingAge === '50+';
    var steps = ['people', 'usage', 'cap', 'buildingAge'];
    if (needsMaint) steps.push('maintenance');
    steps.push('problems');
    return steps;
  }

  function canContinue(state) {
    var steps = getSteps(state);
    var step = steps[state.stepIndex];
    if (step === 'cap')         return state.cap.length === 5;
    if (step === 'people')      return state.people !== '';
    if (step === 'usage')       return state.usage !== '';
    if (step === 'buildingAge') return state.buildingAge !== '';
    if (step === 'maintenance') return state.maintenanceWork !== '' && (state.maintenanceWork === 'none' || state.maintenanceYears !== '');
    if (step === 'problems')    return state.problems.length > 0;
    return false;
  }

  /* ─── RENDER ────────────────────────────────────────────────────────────── */

  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'className') el.className = attrs[k];
        else if (k === 'style') el.style.cssText = attrs[k];
        else el.setAttribute(k, attrs[k]);
      });
    }
    if (children) {
      if (typeof children === 'string') el.innerHTML = children;
      else if (Array.isArray(children)) children.forEach(function (c) { if (c) el.appendChild(c); });
      else el.appendChild(children);
    }
    return el;
  }

  function renderRadio(options, value, onChange) {
    var wrap = h('div', { className: 'pq-options' });
    options.forEach(function (opt) {
      var selected = value === opt.key;
      var row = h('div', { className: 'pq-option' + (selected ? ' selected' : '') });
      var indicator = h('div', { className: 'pq-radio' }, h('div', { className: 'pq-radio-dot' }));
      var label = h('span', { className: 'pq-option-label' }, opt.label);
      row.appendChild(indicator);
      row.appendChild(label);
      row.addEventListener('click', function () { onChange(opt.key); });
      wrap.appendChild(row);
    });
    return wrap;
  }

  function renderCheckbox(options, selected, onToggle) {
    var wrap = h('div', { className: 'pq-options' });
    options.forEach(function (opt) {
      var checked = selected.indexOf(opt.key) !== -1;
      var row = h('div', { className: 'pq-option' + (checked ? ' selected' : '') });
      var box = h('div', { className: 'pq-checkbox' }, checked ? '✓' : '');
      var label = h('span', { className: 'pq-option-label' }, opt.label);
      row.appendChild(box);
      row.appendChild(label);
      row.addEventListener('click', function () { onToggle(opt.key); });
      wrap.appendChild(row);
    });
    return wrap;
  }

  function renderStep(state, container, onUpdate) {
    var steps = getSteps(state);
    var step = steps[state.stepIndex];
    var frag = document.createDocumentFragment();

    if (step === 'cap') {
      frag.appendChild(h('p', { className: 'pq-question' }, 'Qual è il tuo CAP?'));
      frag.appendChild(h('p', { className: 'pq-hint' }, 'Ci serve per stimare la durezza dell\'acqua nella tua zona'));
      var input = h('input', { className: 'pq-cap-input', type: 'text', maxlength: '5', placeholder: 'Es. 20100', value: state.cap });
      input.addEventListener('input', function () {
        var v = this.value.replace(/\D/g, '').slice(0, 5);
        this.value = v;
        state.cap = v;
        state.capInfo = v.length === 5 ? getCapData(v) : null;
        onUpdate();
      });
      frag.appendChild(input);
      if (state.capInfo) {
        var card = h('div', { className: 'pq-cap-card' });
        card.appendChild(h('span', { className: 'pq-cap-icon' }, '💧'));
        var info = h('div');
        info.appendChild(h('p', { className: 'pq-cap-city' }, state.capInfo.city + (state.capInfo.region ? ', ' + state.capInfo.region : '')));
        info.appendChild(h('p', { className: 'pq-cap-hardness' }, 'Durezza acqua: <b>' + state.capInfo.hardness + '</b>'));
        card.appendChild(info);
        frag.appendChild(card);
      }
    }

    if (step === 'people') {
      frag.appendChild(h('p', { className: 'pq-question' }, 'Quante persone vivono in casa?'));
      frag.appendChild(renderRadio(PEOPLE_OPTIONS, state.people, function (v) { state.people = v; onUpdate(); }));
    }

    if (step === 'usage') {
      frag.appendChild(h('p', { className: 'pq-question' }, 'Come usi l\'acqua filtrata?'));
      frag.appendChild(renderRadio(USAGE_OPTIONS, state.usage, function (v) { state.usage = v; onUpdate(); }));
    }

    if (step === 'buildingAge') {
      frag.appendChild(h('p', { className: 'pq-question' }, 'Quanti anni ha il tuo edificio?'));
      frag.appendChild(renderRadio(BUILDING_OPTIONS, state.buildingAge, function (v) { state.buildingAge = v; onUpdate(); }));
    }

    if (step === 'maintenance') {
      frag.appendChild(h('p', { className: 'pq-question' }, 'Lavori di manutenzione'));
      frag.appendChild(h('p', { className: 'pq-hint' }, 'Sono stati effettuati lavori alla rete idrica dell\'edificio negli ultimi 10 anni?'));
      frag.appendChild(h('p', { className: 'pq-section-label' }, 'Tipo di lavori'));
      frag.appendChild(renderRadio(WORK_TYPE_OPTIONS, state.maintenanceWork, function (v) { state.maintenanceWork = v; state.maintenanceYears = ''; onUpdate(); }));
      if (state.maintenanceWork && state.maintenanceWork !== 'none') {
        frag.appendChild(h('p', { className: 'pq-section-label' }, 'Quando?'));
        frag.appendChild(renderRadio(WORK_YEARS_OPTIONS, state.maintenanceYears, function (v) { state.maintenanceYears = v; onUpdate(); }));
      }
    }

    if (step === 'problems') {
      frag.appendChild(h('p', { className: 'pq-question' }, 'Hai riscontrato problemi con l\'acqua?'));
      frag.appendChild(h('p', { className: 'pq-hint' }, 'Puoi selezionare più opzioni'));
      frag.appendChild(renderCheckbox(PROBLEM_OPTIONS, state.problems, function (key) {
        if (key === 'none') {
          state.problems = ['none'];
        } else {
          var without = state.problems.filter(function (p) { return p !== 'none'; });
          var idx = without.indexOf(key);
          state.problems = idx !== -1 ? without.filter(function (p) { return p !== key; }) : without.concat([key]);
        }
        onUpdate();
      }));
    }

    container.appendChild(frag);
  }

  function renderResults(state, container, onRestart, onComplete) {
    var answers = {
      cap: state.cap,
      people: state.people,
      usage: state.usage,
      buildingAge: state.buildingAge,
      maintenanceWork: state.maintenanceWork || 'none',
      maintenanceYears: state.maintenanceYears || null,
      problems: state.problems,
    };
    var result = calculateFilterDuration(answers, ['tap']);

    if (typeof onComplete === 'function') onComplete(result, answers);

    container.appendChild(h('p', { className: 'pq-results-title' }, 'Ecco la stima per il tuo filtro'));
    container.appendChild(h('p', { className: 'pq-results-sub' }, 'Basata sulla durezza dell\'acqua a ' + result.capInfo.city + ' e sul tuo utilizzo'));

    var waterInfo = h('div', { className: 'pq-water-info' });
    waterInfo.innerHTML = '💧 Acqua di <b>' + result.capInfo.city + '</b>: durezza <b style="color:#378add">' + result.capInfo.hardness + '</b>';
    container.appendChild(waterInfo);

    var FILTER_COLORS = {
      tap:    { bg: '#eaf3de', icon: '🚰', color: '#639922' },
      shower: { bg: '#e6f1fb', icon: '🚿', color: '#378add' },
    };

    ['tap'].forEach(function (id) {
      var p = result.products[id];
      var fc = FILTER_COLORS[id];
      var pct = Math.round((p.days / PRODUCTS[id].maxDays) * 100);

      var card = h('div', { className: 'pq-result-card' });

      var header = h('div', { className: 'pq-result-card-header' });
      var icon = h('div', { className: 'pq-result-icon', style: 'background:' + fc.bg }, fc.icon);
      var nameWrap = h('div');
      nameWrap.appendChild(h('p', { className: 'pq-result-name' }, p.name));
      nameWrap.appendChild(h('p', { className: 'pq-result-hardness' }, 'Durata stimata'));
      header.appendChild(icon);
      header.appendChild(nameWrap);
      card.appendChild(header);

      card.appendChild(h('p', { className: 'pq-result-days' }, String(p.days)));
      card.appendChild(h('p', { className: 'pq-result-days-label' }, 'giorni stimati'));

      var barBg = h('div', { className: 'pq-result-bar-bg' });
      var fill = h('div', { className: 'pq-result-bar-fill', style: 'width:' + pct + '%;background:' + fc.color });
      barBg.appendChild(fill);
      card.appendChild(barBg);
      card.appendChild(h('p', { className: 'pq-result-months' }, 'Circa ' + p.months + ' mesi'));

      container.appendChild(card);
    });

    var restartBtn = h('button', { className: 'pq-restart' }, '↺ Rifai il calcolo');
    restartBtn.addEventListener('click', onRestart);
    container.appendChild(restartBtn);
  }

  /* ─── WIDGET PRINCIPALE ─────────────────────────────────────────────────── */

  function render(container, state, opts) {
    // Salva posizione cursore per il CAP input
    var prevCapCursor = null;
    var prevCapInput = container.querySelector('.pq-cap-input');
    if (prevCapInput && document.activeElement === prevCapInput) {
      prevCapCursor = prevCapInput.selectionStart;
    }

    container.innerHTML = '';
    var steps = getSteps(state);
    var total = steps.length;
    var isLast = state.stepIndex === total - 1;

    // Step dots (pallini numerati)
    var stepsNav = h('div', { className: 'pq-steps-nav' });
    for (var i = 0; i < total; i++) {
      var dotClass = 'pq-step-dot';
      if (i === state.stepIndex) dotClass += ' active';
      else if (i < state.stepIndex) dotClass += ' done';
      stepsNav.appendChild(h('div', { className: dotClass }, String(i + 1)));
      if (i < total - 1) {
        var lineClass = 'pq-step-line';
        if (i < state.stepIndex) lineClass += ' done';
        stepsNav.appendChild(h('div', { className: lineClass }));
      }
    }
    container.appendChild(stepsNav);

    // Contenuto step
    var stepWrap = h('div');
    renderStep(state, stepWrap, function () { render(container, state, opts); });
    container.appendChild(stepWrap);

    // Ripristina focus sul CAP input dopo re-render
    if (steps[state.stepIndex] === 'cap') {
      var newCapInput = container.querySelector('.pq-cap-input');
      if (newCapInput && prevCapCursor !== null) {
        newCapInput.focus();
        newCapInput.setSelectionRange(prevCapCursor, prevCapCursor);
      }
    }

    // Bottoni
    var buttons = h('div', { className: 'pq-buttons' });
    if (state.stepIndex > 0) {
      var backBtn = h('button', { className: 'pq-back' }, '← Indietro');
      backBtn.addEventListener('click', function () { state.stepIndex--; render(container, state, opts); });
      buttons.appendChild(backBtn);
    }
    var ok = canContinue(state);
    var nextBtn = h('button', { className: 'pq-next' }, isLast ? 'Calcola risultati' : 'Continua →');
    if (!ok) nextBtn.setAttribute('disabled', 'disabled');
    nextBtn.addEventListener('click', function () {
      if (!ok) return;
      if (isLast) {
        container.innerHTML = '';
        renderResults(state, container, function () {
          var fresh = createState();
          render(container, fresh, opts);
        }, opts && opts.onComplete);
      } else {
        state.stepIndex++;
        render(container, state, opts);
      }
    });
    buttons.appendChild(nextBtn);
    container.appendChild(buttons);
  }

  /* ─── CSS INJECTION ─────────────────────────────────────────────────────── */

  function injectCSS() {
    if (document.getElementById('purit-quiz-css')) return;
    var style = document.createElement('style');
    style.id = 'purit-quiz-css';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  /* ─── API PUBBLICA ──────────────────────────────────────────────────────── */

  function init(selector, opts) {
    injectCSS();
    var container = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!container) { console.error('PuritQuiz: elemento non trovato:', selector); return; }
    container.className = (container.className ? container.className + ' ' : '') + 'pq-wrap';
    var state = createState();
    render(container, state, opts || {});
  }

  /* ─── EXPORT ────────────────────────────────────────────────────────────── */

  if (typeof window !== 'undefined') {
    window.PuritQuiz = { init: init };
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { init: init };
  }

})();
